import React, { useState, useEffect } from 'react';
import { fetchWithCSRF } from '../utils/csrfUtils';
import supabase from '../supabaseClient';

const DietPreferencesStep = ({ onSave, initialValues = [], sessionToken }) => {
    const [diets, setDiets] = useState([]);
    const [selectedDiets, setSelectedDiets] = useState(initialValues);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchDiets = async () => {
            try {
                if (!sessionToken) {
                    console.error('No session token available');
                    return;
                }
                
                const response = await fetchWithCSRF('/api/v1/diet', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    console.log("data(dietPreferencesStep): ", data);
                    setDiets(data);
                }
            } catch (error) {
                console.error('Error fetching diets:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchDiets();
    }, [sessionToken]);

    const handleDietToggle = (dietId) => {
        setSelectedDiets(prev => 
            prev.includes(dietId)
                ? prev.filter(id => id !== dietId)
                : [...prev, dietId]
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Only proceed if at least one diet is selected
        if (selectedDiets.length > 0) {
            onSave(selectedDiets);
        }
    };

    const getDynamicMessage = () => {
        const selectedDietNames = diets
            .filter(diet => selectedDiets.includes(diet.id))
            .map(diet => diet.name);

        if (selectedDietNames.length === 0) {
            return "Select everything you're open to eating. AutoChef will only generate meals that match your picks.";
        }

        if (selectedDietNames.length === 1) {
            return (
                <>
                    Your meal plans will only include <b>{selectedDietNames[0]}</b> recipes.
                </>
            );
        }

        if (selectedDietNames.length === 2) {
            return (
                <>
                    Your meal plans will include <b>{selectedDietNames[0]}</b> and <b>{selectedDietNames[1]}</b> recipes.
                </>
            );
        }

        if (selectedDietNames.length === 3) {
            return (
                <>
                    Your meal plans will include <b>{selectedDietNames[0]}</b>, <b>{selectedDietNames[1]}</b>, and <b>{selectedDietNames[2]}</b> recipes.
                </>
            );
        }

        return "Your meal plans will include recipes that match any of your selections.";
    };

    if (loading) {
        return <div className="text-center">Loading...</div>;
    }

    return (
        <div className="preference-step">
            <h2>What do you like to eat?</h2>
            {/* <p>Choose everything you're open to eating.</p> */}
            <p className="dynamic-feedback">{getDynamicMessage()}</p>
            
            <form onSubmit={handleSubmit}>
                <div className="diet-options-grid mb-4">
                    {diets.map(diet => (
                        <button
                            key={diet.id}
                            type="button"
                            className={`diet-selection-button ${selectedDiets.includes(diet.id) ? 'active' : ''}`}
                            onClick={() => handleDietToggle(diet.id)}
                        >
                            <img 
                                src={`/icons/dietOptions/${diet.name.replace(/\s+/g, '')}.jpg`}
                                alt={`${diet.name} icon`}
                                className="diet-button-icon"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                }}
                            />
                            <span>{diet.name}</span>
                        </button>
                    ))}
                </div>
                {/* <div>Please select at least one option.</div> */}
                
                <div className="d-flex justify-content-end">
                    <button 
                        type="submit" 
                        className={`btn btn-primary ${selectedDiets.length === 0 ? 'disabled' : ''}`}
                        disabled={selectedDiets.length === 0}
                        title={selectedDiets.length === 0 ? "Please select at least one dietary preference" : ""}
                    >
                        Continue
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DietPreferencesStep; 